import React, { useState } from "react";
import { ThemeProvider } from "@mui/material";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers";
import { observer } from "mobx-react-lite";

import "./DatePicker.scss";
import { translationService } from "../../services/translation/TranslationService";
import useThemeService, { MUIComponentsTheme } from "../../services/theme-service/ThemeService";
import { CalendarAdornment, CloseAdornment } from "./DataComponents";

interface DatePickerProps {
  value: Date | null;
  onChange: (date: Date | null | undefined) => void;
  className?: string;
  isRequired?: boolean;
  placeholderKey?: string;
  onlyYear?: boolean;
}

export default observer(function DatePicker(props: DatePickerProps) {
  const { value, onChange, className, isRequired, placeholderKey, onlyYear } = props;
  const { themeClass } = useThemeService();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <ThemeProvider theme={MUIComponentsTheme}>
      <MUIDatePicker
        className={`${themeClass(["date-picker"])} ${className || ""}`}
        value={value}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        onChange={() => {}}
        onAccept={onChange}
        views={onlyYear ? ["year"] : ["year", "month", "day"]}
        openTo={onlyYear ? "year" : "day"}
        slotProps={{
          textField: {
            onClick: () => setIsOpen(true),
            onFocus: (e: any) => e.target.blur(e),
            placeholder: translationService.translate(placeholderKey!),
            InputProps: {
              endAdornment: (
                <div className="adornments-container">
                  <CloseAdornment onChange={onChange} isEnabled={!isRequired && value !== null} />
                  <CalendarAdornment onClick={() => setIsOpen(true)} />
                </div>
              ),
            },
            inputProps: {
              readOnly: true,
            },
          },
        }}
      />
    </ThemeProvider>
  );
});
